export default __webpack_public_path__ + "static/media/direct-message.1bd76fce.svg";